import { render, staticRenderFns } from "./readMe.vue?vue&type=template&id=1f1b2a72&scoped=true&"
import script from "./readMe.vue?vue&type=script&lang=js&"
export * from "./readMe.vue?vue&type=script&lang=js&"
import style0 from "./readMe.vue?vue&type=style&index=0&id=1f1b2a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b2a72",
  null
  
)

export default component.exports